import { Modal, Switch } from '@/components';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useDevToolsStorage } from '../_hooks/local-storage';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export const DebugModeModal: FC<Props> = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  const { devtoolState, setDevtoolState } = useDevToolsStorage();

  return (
    <Modal
      title={t('dev-tools.debug-mode')}
      open={isOpen}
      onCancel={onClose}
      footer={null}
      width={600}
    >
      <ul>
        <li>0/null対応の場合に打ち消しと表示</li>
        <li>コメント箇所指定がkeyで表示される</li>
        <li>batch出力時PDFを常に表示する</li>
      </ul>
      <Switch
        checked={devtoolState?.isDebugMode}
        onChange={(checked) => setDevtoolState({ isDebugMode: checked })}
        checkedLabel={t('switch-on')}
        unCheckedLabel={t('switch-off')}
      />
    </Modal>
  );
};
